<template>
    <div id="ContainerOrder">
        <div class="row">
            <div class="col-12">
                <MdTitleRegInfo
                    v-bind:RegistrationInfo="isSchedulerDB ? PatientTitle : RegistrationInfo" 
                    v-bind:titlePrefix="this.Mode ? $t('Orders.Edit') : $t('Orders.Add')" 
                    v-bind:titleRef="'titleElementOrdersList'"
                    v-bind:patientCode="this.$route.params.id">
                </MdTitleRegInfo>

                <b-row>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientAllergies
                            v-bind:NoUseClass="false"
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddAllergy="'AddAllergyMed'"
                            v-bind:VisibleAllergy="true"                    
                            v-bind:UseColumnDinamic="true"
                            v-bind:Column="'col-md-12'"                   
                            v-bind:PatientCode="this.$route.params.id"
                            v-bind:NoValidateChanges="true">						
                        </MdPatientAllergies>
                    </b-col>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientSpecialPrecautions	
                            v-bind:NoUseClass="false" 
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddSpecialPrecautions="'AddSpecialPrecautionMed'"                   
                            v-bind:VisibleSpecialPrecautions="true"
                            v-bind:UseColumnDinamic="true"
                            v-bind:Column="'col-md-12'"
                            v-bind:PatientCode="this.$route.params.id"
                            v-bind:NoValidateChanges="true">						
                        </MdPatientSpecialPrecautions>        
                    </b-col>
                    <b-col md="4" lg="4" sm="12">
                        <MdPatientMarsAlert 	
                            v-bind:NoUseClass="false" 
                            v-bind:UseFixedMiddleClass="true"
                            v-bind:ModalIdAddMarksAlert="'AddMarsAlertsMed'"
                            v-bind:VisibleMarsAlert="true"                   
                            v-bind:UseColumnDynamic="true"
                            v-bind:Column="'col-md-12'"
                            v-bind:PatientCode="this.$route.params.id"
                            v-bind:NoValidateChanges="true">						
                        </MdPatientMarsAlert>
                    </b-col>
                </b-row>

                <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
                    <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                    <div class="flex-grow-1">
                        <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
                    </div>
                </div>
            </div>
        </div>

        <MdTitle v-bind:VisibleInfo="false" v-bind:ReadOnlyInfo="Order.orderName === null" v-bind:Text="CreatedBy" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        
        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Medication.Prescriber')"
                    v-bind:Options="PrescriberList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'code'"
                    v-bind:AllowEmpty="false"
                    v-bind:Model="ModelPrescriber"    
                    v-bind:Multiple="false"  
                    v-bind:isRequired="true"
                    v-bind:isValid="isPrescriberValid"                              
                    :Input="ChangeDropDownPrescriber"
                    v-bind:FeedBackText="$t('Insurance.InsuranceTypeRequired')"
                    :IsDisabled="isReadOnly || internalStatusReadOnly"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12" v-if="!this.physiciansOrdersOptions.byPassPhysicianSignature">
                <MdCheckBox
                    v-bind:Label="$t('MdNote.Sign')"
                    v-bind:Name="'checkboxAdd-Sign'" 
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:UncheckedValue="false"              
                    v-model="isSigned"
                    v-on:change="onSignature"
                    v-bind:Tag="'SignMedication'"  
                    :isReadOnly="isReadOnly || Order.orderStatus == 'VOID' || Order.isSigned || internalStatusReadOnly"  
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Order.OrderType')"
                    v-bind:Options="OrderTypeList"
                    v-bind:FieldDescription="'description'"
                    v-bind:FieldCode="'code'"
                    v-bind:AllowEmpty="false"
                    v-bind:Model="Order.orderType"    
                    v-bind:Multiple="false"                                
                    :Input="ChangeDropDownOrderType"
                    :IsDisabled="isReadOnly || internalStatusReadOnly"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="6" md="6" sm="12">
                <MdLookupMultiple
                    v-bind:ModelCode="Order.orderCode"
                    v-bind:ModelDescription="Order.orderName"
                    v-bind:Label="$t('Order.Order')"                             
                    v-bind:RefCode="'Orders'"  
                    v-bind:Api="OrderNameCall"
                    v-bind:OptionParamList="ParamList"                                                   
                    v-bind:FieldCode="'code'"   
                    v-bind:modelFilter="modelFilter"                         
                    v-bind:FieldDescription="'name'"
                    :IsDisabled="isReadOnly || internalStatusReadOnly"   
                    v-bind:isValid="this.isOrderValid"
                    :InvalidFeedback="this.TextOrders"                            
                    v-bind:isRequired="true"      
                    :ChangeFilter="ChangeFilter"                         
                    :SearchTitle="$t('Orders.Orders')"
                    :GetValues="onCodeConditionOk"                     
                    :SearchFieldCode="'code'"
                    v-bind:Fields="BaseFieldsOrder"
                />
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Medication.Usage')"
                    v-bind:Options="UsageList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:AllowEmpty="false"
                    v-bind:Model="Order.usage"    
                    v-bind:Multiple="false"                                
                    :Input="ChangeDropDownUsage"
                    :IsDisabled="isReadOnly || usageIsReadOnly || internalStatusReadOnly"
                />
            </b-col>
        </b-row>

        <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Medication.Days')"
                    v-bind:Name="'Days'"
                    v-bind:TypeProp="'number'"                      
                    v-bind:Min="'1'"
                    v-bind:Max="'1000'"
                    v-bind:isRequired="true"
                    v-bind:isValid="isDayValid"
                    :InvalidFeedback="$t('Insurance.InvalidInsuranceCode')"
                    v-model.number="Order.day"
                    v-on:blur="OnBlurDay($event)"
                    v-on:change="onChangeDay($event)"
                    v-bind:isReadOnly="isReadOnly || frecuencyMode === 'STAT' || frecuencyMode === '' || internalStatusReadOnly"
                />   
            </b-col> 
            <b-col lg="3" md="3" sm="12">
                <MdLookup
                    v-bind:ModelCode="Order.frequencyCode"
                    v-bind:ModelDescription="Order.frequencyDescription"
                    v-bind:Label="$t('Shared.Frequency')"
                    v-bind:RefCode="'Frequency'"  
                    v-bind:AuxFields="this.FrequencyAuxFields"                     
                    v-bind:Api="'DrugFrequencyHeaders?AdministrationFrequencies=true'"
                    v-bind:FieldCode="'code'"  
                    v-bind:isValid="isFrequencyValid"
                    v-bind:isRequired="true"                         
                    v-bind:FieldDescription="'description'"
                    :InvalidFeedback="this.TextFrequency"    
                    :IsDisabled="isReadOnly || internalStatusReadOnly || Order.orderCode == ''"    
                    :SearchTitle="$t('Shared.Frequency')"
                    :GetValues="onCodeConditionOk"                     
                    :SearchFieldCode="'Code'"
                    v-bind:Fields="BaseFields"
                />
            </b-col>     
            <b-col lg="3" md="3" sm="12">
                <MdButton
                    v-bind:Label="$t('Order.Time')"
                    v-bind:isReadOnly="(Order.orderCode != '' && Order.frequencyCode && !isReadOnly && frecuencyMode !== 'STAT' && frecuencyMode !== 'PRN') && !internalStatusReadOnly ? false : true"
                    v-bind:Name="'btn_time'"
                    v-bind:ClassProp="'secondary mt-3 btn-login'"
                    v-on:click="OpenDosageTime"/>                    
            </b-col>
        </b-row>

        <b-row>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Medication.StartDateAndTime')"
                    v-bind:Name="'sDate'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Mask="'##/##/#### ##:## AA'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isRequired="true"
                    v-bind:isValid="isStartTimeValid"
                    v-model="startDateTime"
                    v-on:change="onChangeStartDateTime($event)"
                    v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                />   
            </b-col>
            <b-col md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Medication.EndDateAndTime')"
                    v-bind:Name="'eDate'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Mask="'##/##/#### ##:## AA'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-bind:isRequired="true"
                    v-bind:isValid="isEndTimeValid"
                    v-model="endDateTime"
                    v-on:change="onChangeEndDateTime($event)"               
                    v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
            />   
            </b-col> 
            <b-col md="3" lg="3" sm="12">
                <MdSelect
                    v-bind:Label="$t('Order.OrderStatus')"
                    v-bind:Options="OrderStatusList"
                    v-bind:FieldDescription="'name'"
                    v-bind:FieldCode="'value'"
                    v-bind:AllowEmpty="false"
                    v-bind:Model="Order.orderStatus"    
                    v-bind:Multiple="false"                                
                    :Input="ChangeDropDownOrderStatus"
                    :IsDisabled="isReadOnly"
                />
            </b-col> 
            <b-col v-if="Order.orderStatus == 'Inactive'"  md="3" lg="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Medication.stopDateTime')"
                    v-bind:Name="'eDate'"
                    v-bind:TypeProp="'text'" 
                    v-bind:Mask="'##/##/#### ##:## AA'"
                    v-bind:Min="'1900-01-01'"
                    v-bind:Max="'2200-12-31'"
                    v-model="Order.stopDateTime"
                    v-on:change="onChangeStopDateTime($event)"               
                    v-bind:isReadOnly="isReadOnly"
                />   
            </b-col>
        </b-row>

        <MdTitle v-bind:Text="$t('Order.TherapistNotes')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>
        <b-row>
            <b-col md="12" lg="12">
                <MdMemo
                    v-bind:Name="'textarea_notes'"
                    v-bind:Rows="'3'"
                    v-bind:MaxRows="'6'"
                    v-bind:MaxLength="'500'"
                    v-model="Order.notes"
                    v-bind:isReadOnly="isReadOnly || internalStatusReadOnly"
                />                                     
            </b-col>
        </b-row> 

        <div class="space-actions"></div>
        <div class="page-actions">
            <MdButton
                v-bind:Label="$t('Shared.Back')"
                v-bind:Name="'btn_list_medications'"
                v-bind:ClassProp="'secondary mx-2 btn-login'"
                v-on:click="DiscardChanges"/>

            <MdButton v-if="!this.Mode"
                v-bind:Label="$t('Shared.Save')"
                style="z-index:99999"
                v-bind:ClassProp="'primary btn-login mx-2'"
                v-on:click="SaveOrEdit"                
                v-bind:isReadOnly="!this.pendingChanges"               
                v-bind:Name="'btn_save_orders'">
            </MdButton>

            <b-button-group variant="primary" v-if="this.Mode">
                <b-button :disabled="!this.pendingChanges" variant="primary" v-on:click="SaveOrEdit">{{$t('Shared.Save')}}</b-button>
                <b-dropdown variant="primary" class="ms-2">
                    <b-dropdown-item v-on:click="CopyOrder()" v-if="this.Mode && !isReadOnly"> {{$t('Orders.CopyOrder')}}</b-dropdown-item>
                    <b-dropdown-item v-on:click="CopyDCOrder()" v-if="this.Mode && !isReadOnly">{{$t('Orders.CopyDCOrder')}}</b-dropdown-item>
                    <b-dropdown-item v-on:click="InactiveOrders()"  v-if="this.setVisibilityInactiveOrder() && !isReadOnly">{{$t('Orders.InactiveOrder')}}</b-dropdown-item>
                    <b-dropdown-item v-on:click="showReport" v-if="this.Mode">{{ $t('Shared.Report') }}</b-dropdown-item>
                </b-dropdown>
            </b-button-group>
        </div>

        <ModalTime
            v-bind:marsTimes="marsTimes"
            v-bind:ReadOnly="isReadOnly"
            @OnModalDosageTimeCancel="HideModalTime"
            @RefreshDosageTime="RefreshTime"
            v-if="VisibleDosageTime"
            v-bind:ModalId="'modalIdDosageTime'"
            v-bind:TitleWindow="$t('Medication.TitleModalDosageTime')"        
        />

        <MdPasswordDlg v-if="showSignPassword" 
            v-bind:Type="TypePassWord"
            v-bind:EmployeeCode="EmployeeCodeSelected"
            @getModalPassword="onModalPasswordResult($event)"
        />
    </div>
</template>

<script>
import Permission from '@/common/Permission'
import ShowMessage from '@/components/messages/ShowMessage.js'
import DBFunctions from '@/common/DBFunctions.js'
import EnumService from '@/services/enum.service'
import Utils from "@/common/utils"
import OrdersService from '@/services/orders.service'
import StorageService from '@/services/storage.service'
import MedicationService from '@/services/medication.service'
import PatientService from '@/services/patient.service'
import GlobalService from '@/services/global.service'
import ModalTime from '@/components/pages/clinical/orders/modalTime'
import { EventBus } from '@/event-bus.js'
import moment from "moment";

export default {
    beforeRouteLeave(to, from, next) {
        if (!this.isReadOnly && this.pendingChanges) {
            this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
                title: this.$t('Msg.Confirm'),
                okTitle: this.$t('Shared.BtnSave'),
                cancelTitle: this.$t('Shared.BtnDismiss'),
                footerClass: 'p-2',
                titleClass: 'modal-title modal-type-warning'
            })
            .then(async value => {
                if(!value){
                    next();
                } else {
                    await this.ClickOffRoute();
                    var f = this.WasSaved;             
                    if(f){
                        next();
                    }
                }
            })		
        } else {
            next()
        }
    },

    mixins: [ShowMessage, DBFunctions, Permission],
    name: 'Orders',
    components: {
        ModalTime
    },

    data() {
        return {
            RegistrationInfo:{},
            PatientInfo:{},
            OptionsRightMenu:{
                visible:true,
                ItemsList:[],
                btnvisible:true,
                itemdisabled: false,
                PatientCode:''         
            },
            isSchedulerDB: false,
            currentAppointmentDB:{
                guid:'',
                activitytypecode:'',
                employee: {
                    firstname:"",
                    lastname:""
                }
            }, 
            PatientTitle:{      
                programName:'',
                fullName:'',
                admitDate:'',
                dischargeDate:'',
                dob:'',
                activitytypename:'',
                startdatetime:'',
                ageFormatted:''
            },
            pendingChanges: false,
            Mode:this.$attrs.editMode,
            isReadOnly:false,
            CreatedBy:'',
            Order: {
                patientCode:this.$route.params.id,
                AdmissionRecordId:this.isSchedulerDB ? this.currentAppointmentDB && this.currentAppointmentDB.recId : this.$route.params.recordid,
                orderCode: '',
                orderName: '',
                internalStatus: 'ORDERED',
                notes: '',
                prescriber: '',
                usage:'',
                day:1,
                frequencyCode:'',
                frequencyDescription:'',
                marsTimes:[],
                orderStatus:'',
                isSigned:false,
                issueType:'Electronic',
                orderType:''
            },
            internalStatusReadOnly: false,
            PrescriberList: [],
            ModelPrescriber: {code:"",name:""},
            isPrescriberValid: true,
            defaultDoctor: '',
            UsageList: EnumService.ClinicalMedicationUsage,
            usageIsReadOnly: false,
            OrderNameCall:"PhysiciansOrders/AllOrders?",
            ParamList:[
                {
                    code:1,
                    description:this.$t('Order.Param.AllOrders'),
                    resource:"PhysiciansOrders/AllOrders?"
                },
            ],
            modelFilter: {code:1,description:this.$t('Order.Param.AllOrders'), resource:"PhysiciansOrders/AllDrugs?"},
            isOrderValid:true,
            TextOrders:this.$t('Msg.RequiredField'),
            BaseFieldsOrder:[
                { key: 'code', sortable: true, label: this.$t('Order.Code')},
                { key: 'name', sortable: true, label: this.$t('Order.Name')},
                { key: 'description', sortable: true, label: this.$t('Order.Description')},
                { key: 'category', sortable: true, label: this.$t('Order.Category')},
            ],
            isDayValid:true,
            frecuencyMode: '',
            FrequencyAuxFields:['hoursBetweenDoses','mode','recurEveryDays','timesPerDay'],
            TextFrequency:this.$t('Msg.RequiredField'),
            isFrequencyValid:true,
            BaseFields:[
                { key: 'description', sortable: true, label: this.$t('Shared.Description')},
                { key: 'code', sortable: true, label: this.$t('Shared.Code')},
                { key: 'mode', sortable: true, label: this.$t('Medication.Mode')},
            ],
            VisibleDosageTime: false,
            isStartTimeValid:true,
            isEndTimeValid:true,
            startDateTime:null,
            endDateTime:null,
            OrderStatusList:EnumService.ClinicalMedicationOrderStatus,
            marsTimes:[],
            DateandTimeUpdated: null,
            DefaultDays: null,
            RestrictChange: 'N',
            DateNow: null,
            physiciansOrdersOptions: {
                byPassPhysicianSignature: false,
                usePatientDoctorAsPrescriber: false,
                inactiveOrdersAtAnyStatus: false,
                copyActiveOrders: false,
                showAllOrders: false,
                showAllMissedOrders: false
            },
            IsCurrentOrder: false,
            isSigned:false,
            showSignPassword:false,
            EmployeeCodeSelected:'',
            TypePassWord:'',
            OrderTypeList:[],
            OrderType:'',
            OffRoute:false,
            clickBack:false
        }
    },

    methods: {
        async ClickOffRoute(){
            this.OffRoute = true;       
            await this.SaveOrEdit();
        },

        DiscardChanges() {
            this.clickBack = true;
            if (this.isSchedulerDB) {
                this.$router.push({
                    name: "Appointments-orders",
                    params: { id: this.$route.params.id, actId: this.$route.params.actId },
                });
            } else {
                this.$router.push({
                    name: "Clinical-orders",
                    params: { id: this.$route.params.id, recordid: this.$route.params.recordid },
                });   
            }
        },

        CopyOrder() {
            this.$emit('load', true);
            this.SendCopyOrder(false)
        },

        CopyDCOrder() {
            this.$emit('load', true);
            this.SendCopyOrder(true)
        },


        InactiveOrders() {
            const params = {
                "recordIDList": [ this.$route.params.recId ]
            }
            
            OrdersService
                .InactiveOrders(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.GotoOrdersList();
                        
                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Orders.MsgOrderInactive'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                        , 50); 
                    }     
                    this.$emit('load', false);                        
                })
                .catch((error) => {   
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
        },

        async SendCopyOrder(stopPreviousPresc){
            if (this.physiciansOrdersOptions && this.physiciansOrdersOptions.copyActiveOrders){
                await this.getCurrentOrder(stopPreviousPresc ? 'COPY_DC' : 'COPY')
            
                if (this.IsPrescriptionCurrent) {
                    this.$bvModal
                        .msgBoxConfirm(this.$t('Orders.MsgCurrentOrder'), {
                            title: this.$t('Medication.Medications'),
                            okTitle: this.$t('Shared.Continue'),
                            cancelTitle: this.$t('Shared.BtnCancel'),
                            footerClass: 'p-2',
                            titleClass: 'modal-title modal-type-warning',
                            id:'modal_delete_vitals'
                        })
                        .then(value => {
                            if(value) {
                                this.setCopyOrder(stopPreviousPresc)
                            }
                        })
                } else {
                    this.setCopyOrder(stopPreviousPresc)
                }
            } else {
                    this.setCopyOrder(stopPreviousPresc)
            }
        },

        setCopyOrder(stopPreviousPresc) {
            const params = {
                "oldRecordID": `${this.$route.params.recId}`,
                "admissionRecordID": this.isSchedulerDB ? this.currentAppointmentDB && String(this.currentAppointmentDB.recId) : this.$route.params.recordid,
                "stopPreviousPresc": stopPreviousPresc
            }
            OrdersService
                .CopyOrder(params)
                .then((response) => {
                    if(response.status == '200'){
                        this.showMessage(this.$t('Orders.Orders'),this.$t('Orders.MsgOrderCopied'));
                        const orderId = response.data;
                        setTimeout(() => {
                            this.GotoNewOrder(`${orderId}`);
                        }, 50)
                    }           
                    this.$emit('load', false);                  
                })
                .catch((error) => {   
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
        },

        GotoNewOrder(orderId) {
            if (this.isSchedulerDB) {
                this.$router.push({ name: "Appointments-orders-details", 
                    params: { recId: orderId, actId: this.$route.params.actId } });
            } else {
                this.$router.push({ name: "Clinical-orders-details", params: { recId: orderId } });
            }
        },

        showReport() {

        },

        SaveOrEdit() {
            if (this.isReadOnly == false && this.pendingChanges) {
                if (this.physiciansOrdersOptions && this.physiciansOrdersOptions.copyActiveOrders && !this.isVoidOrInactive()){                
                    if (this.IsCurrentOrder) {
                        this.$bvModal.msgBoxConfirm(this.$t('Orders.MsgCurrentOrder'), {
                                title: this.$t('Orders.Orders'),
                                okTitle: this.$t('Shared.Continue'),
                                cancelTitle: this.$t('Shared.BtnCancel'),
                                footerClass: 'p-2',
                                titleClass: 'modal-title modal-type-warning',
                                id:'modal_delete_vitals'
                            })
                            .then(value => {
                                if(value) {
                                    this.DoAction();
                                }
                            })
                    } else {
                        this.DoAction();
                    }
                } else {
                    this.DoAction();
                }
            }
        },

        async DoAction() {
            if(this.ValidateRequired()){
                await this.getCurrentOrder('WRITE');
                this.Validate();
                this.WasSaved = true;    
                !this.Mode ? this.AddOrder() : this.UpdateOrder(); 
            }else{                
                this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide"); 
            }
        },

        AddOrder() {
            this.$emit('load', true);
            this.PrepareOrder();   
            OrdersService
                .add(this.ObjData)
                .then((response) => {
                    if(response.status == '200'){
                        this.Order = response.data;   
                        this.pendingChanges = false;  

                        if(!this.OffRoute || this.clickBack){
                            this.GotoOrdersList();
                        }

                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                                title: this.$t('Msg.Success'),
                                autoHideDelay: 5000,
                                variant: "success"
                            })
                        , 50); 
                    }       
                    this.$emit('load', false);                      
                })
                .catch((error) => {   
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                }); 
        },

        UpdateOrder() {
            this.$emit('load', true);       
            this.PrepareOrder();
            OrdersService
                .update(this.$route.params.recId, this.ObjData)
                .then((response) => {
                    if(response.status == '200'){                       
                        this.pendingChanges = false; 

                        if(!this.OffRoute || this.clickBack){
                            this.GotoOrdersList();
                        }

                        setTimeout(() => 
                            this.$bvToast.toast(this.$t('Msg.SavedSuccessfully'), {
                            title: this.$t('Msg.Success'),
                            autoHideDelay: 5000,
                            variant: "success"
                            })
                        , 50); 
                    }  
                    this.$emit('load', false);                  
                })
                .catch((error) => {
                    this.$emit('load', false);
                    this.showResponseErrorMessage(error);
                });
        },

        PrepareOrder (){
            this.ObjData = {
                PatientCode:this.$route.params.id,
                AdmissionRecordId: this.isSchedulerDB ? this.currentAppointmentDB && String(this.currentAppointmentDB.recId) : this.$route.params.recordid,
                PrescriberCode:this.ModelPrescriber.code,
                OrderCode:this.Order.orderCode,
                Usage:this.Order.usage,
                Day:this.Order.day,
                StartDateTime:Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()),
                EndDateTime:Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()),
                OrderStatus:this.Order.orderStatus,
                FrequencyCode:this.Order.frequencyCode,
                Notes:this.Order.notes,
                StopDateTime: Utils.formatterToISO(this.Order.stopDateTime, Utils.getDateTimeFormat()),
                MarsTimes:this.Order.marsTimes,
                IsSigned:this.isSigned,
                OrderType:this.Order.orderType
            }
        },

        ValidateRequired(){
            this.isDrugValid = Utils.isNullOrEmptyString(this.Order.orderCode) ? false : true;
            this.isPrescriberValid = Utils.isNullOrEmptyString(this.ModelPrescriber.code) ? false : true;
            this.isFrequencyValid = Utils.isNullOrEmptyString(this.Order.frequencyCode) ? false : true;
            this.isDayValid = this.Order.day <= 0 ? false : true;
            this.isStartTimeValid = this.startDateTime ? true : false;
            this.isEndTimeValid = this.endDateTime ? true: false;

            this.TextOrders = this.Order.orderCode === "" ? this.$t('Msg.RequiredField') : this.$t('Order.InvalidOrder');
            this.TextFrequency = this.Order.frequencyCode === "" ? this.$t('Msg.RequiredField') : this.$t('Medication.InvalidFrequency');

            return this.isDrugValid && this.isPrescriberValid && this.isFrequencyValid && this.isDayValid && this.isStartTimeValid && this.isEndTimeValid;
        },

        async Validate() {
            if (((this.Order.orderStatus??"").trim().toUpperCase() === 'INACTIVE') && (this.Order.stopDateTime === "")  ){
                this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.StopDateCannotbeEmpty'),"error");        
                return;
            }

            if (((this.Order.orderStatus??"").trim().toUpperCase() === 'INACTIVE') && ((this.Order.stopDateTime !== "") || (this.Order.stopDateTime !== null) )  ){
                await this.getDateTimeValidateStopDate();
                const stopDate = moment(this.Order.stopDateTime, Utils.getDateTimeFormat())
                const DNow  = moment(this.DateNow, Utils.getDateTimeFormat())
                if ( stopDate < DNow ){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.TheStopDateMustBeGreaterThanTheCurrentDate'),"error");        
                    return;
                }
            }

            if (((this.Order.orderStatus??"").trim().toUpperCase() !== 'INACTIVE') || (this.Order.orderStatus??"").trim().toUpperCase() !== 'VOID') {
                if (Utils.isNullOrEmptyString(this.Order.patientCode)){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.PatientCodeCannotBeEmpty'),"error");        
                    return;
                }

                if(Utils.isNullOrEmptyString(this.Order.usage)){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.UsageCannotBeEmpty'),"error");        
                    return;
                }

                if( ((this.Order.usage??"").trim().toUpperCase() !== 'INTERNAL') && (this.Order.usage??"").trim().toUpperCase() !== 'HOME'){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.UsageMustBeInternalOrHome'),"error");        
                    return;
                }

                if(Utils.isNullOrEmptyString(this.Order.orderStatus)){
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Medication.RxStatusCannotBeEmpty'),"error");        
                    return;
                }
            }
        },

        GotoOrdersList(){
            if (this.isSchedulerDB) {
                this.$router.push({
                    name: "Appointments-orders",
                    params: { id: this.$route.params.id, actId: this.$route.params.actId },
                });
            } else {
                if(this.$route.name.includes('Clinical-orders')) {
                    this.$router.push({ name: 'Clinical-orders', params: { id: this.$route.params.id, recordid: this.$route.params.recordid }});
                }
            }
        },

        async getOrderByRecId() {
            if (this.Mode) {             
                await OrdersService
                    .get( this.$route.params.recId )
                    .then((response) => {
                        if(response.status == '200' && response.data){                   
                            var order = response.data;
                            
                            order.dateTimeCreated = Utils.formatterDateTimeToString(order.dateTimeCreated);  
                            order.endTime = Utils.formatTimeHm(order.endTime);
                            order.startTime = Utils.formatTimeHm(order.startTime);
                            order.endDate = Utils.formatterDate(order.endDate);
                            order.startDate = Utils.formatterDate(order.issuedDate);
                            order.stopDate = Utils.formatterDate(order.stopDate);
                            order.stopTime = Utils.formatTimeHm(order.stopTime);

                            order.startDateTime = Utils.formatterDateTimeToString(order.startDateTime); 
                            order.endDateTime = Utils.formatterDateTimeToString(order.endDateTime); 

                            order.stopDateTime = Utils.formatterDateTimeToString(order.stopDateTime); 
                            order.orderType = order.orderType?.trim();
                            
                            this.CopyDateTime = order.startDateTime; 
                            this.startDateTime = order.startDateTime; 
                            this.endDateTime = order.endDateTime; 
                        
                            if(order.marsTimes.length > 0){  
                                let arr = [];                  
                                order.marsTimes.forEach((item) => {                       
                                    arr.push({adminTime:Utils.formatTimeHm(item.adminTime)                                                        
                                    });                                    
                                });
                                this.marsTimes = arr;
                            }

                            this.ModelPrescriber.code = order.prescriberCode;
                            this.ModelPrescriber.name = order.prescriberName; 

                            this.frecuencyMode = order.mode;
                            this.isSigned = order.isSigned;

                            this.Order = order;
                            this.CreatedBy = this.$t('Medication.CreatedBy')+ ': '+ order.employeeName+ ' '+ order.dateTimeCreated+ '   ' + '<span class="highlightInTitle blueTitle">'+ this.$t('Medication.internalStatus.'+ this.Order.internalStatus) +'</span>'  ;  
                        }
                    })
                    .catch((error) => {
                        this.showResponseErrorMessage(error);
                    });
            } else {
                this.CreatedBy = this.$t('Medication.CreatedBy') +': '+Utils.strToTitleCase(StorageService.getName()) + '   ' + '<span class="highlightInTitle blueTitle">'+ this.$t('Medication.internalStatus.NEW')+'</span>';             
            }
        },

        async getCurrentOrder(Action) {
            const params = {
                "PatientCode": this.$route.params.id,  
                "OrderCode": this.Order.ordergCode,
                "Mode":  !this.Mode ? this.frecuencyMode : this.Order.mode, 
                "RecordId": this.$route.params.recordid, 
                "Action": Action, 
                "StartDateTime": !this.Mode ? Utils.formatterToISO(this.startDateTime, Utils.getDateTimeFormat()) : Utils.formatterToISO(this.Order.startDateTime, Utils.getDateTimeFormat()), 
                "EndDateTime": !this.Mode ? Utils.formatterToISO(this.endDateTime, Utils.getDateTimeFormat()) : Utils.formatterToISO(this.Order.endDateTime, Utils.getDateTimeFormat()),
                "Day": this.Order.day,
            }

            await OrdersService
                    .IsCurrentOrder(params)
                    .then((response) => {
                        if(response.status == '200'){
                            this.IsCurrentOrder = response.data 
                        }            
                        this.$emit('load', false);                 
                    })
                    .catch((error) => {   
                        this.$emit('load', false);
                        this.showResponseErrorMessage(error);
                    });

        },

        isVoidOrInactive() {
            return this.Order.orderStatus == 'Inactive' || this.Order.orderStatus == 'Void'
        },

        OpenDosageTime(){
            this.VisibleDosageTime = true;
        },

        HideModalTime(){
            this.VisibleDosageTime = false;
        },

        setVisibilityInactiveOrder() {
            let visibility = false

            if (this.Mode && this.Order.orderStatus != 'Inactive') {
                if (this.Order.internalStatus == 'TARSCREATED' || this.physiciansOrdersOptions.inactiveOrdersAtAnyStatus) {
                    visibility = true;
                }
            }
            
            return visibility
        },

        async getDateTimeValidateStopDate() {       
            await GlobalService
                .getDateTime()
                .then((response) => {      
                    if (response.data) {
                        this.DateNow = Utils.formatterDateTimeToString(response.data);
                    }  
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                }); 
        },

        ChangeDropDownPrescriber(item){
            if (item !== null) {
                this.ModelPrescriber = item;
                this.Order.prescriber = item.code;
            } else {
                this.ModelPrescriber = {code:"",name:""};
                this.Order.prescriber = "";
            }
        },

        ChangeDropDownUsage(item){
            if (item !== null) {
                this.Order.usage = item.value;
            } else {
                this.Order.usage = "";
            }
        },

        ChangeDropDownOrderType(item) {
            if (item !== null) {
                this.Order.orderType = item.code;
            } else {
                this.Order.orderType = "";
            }
        },

        ChangeFilter(m){      
            this.modelFilter = m;
        },

        async onCodeConditionOk(result){
            var type = result.FieldName; 
            if (type.indexOf('Orders')  >= 0 ) {
                if (result.code){
                    this.Order.orderCode = result.code.trim();
                    this.Order.OrderName = result.description.trim();
                    this.setDayQuantityByOrder();
                    
                    if ( this.DefaultDays > 0 )
                        this.Order.day = this.DefaultDays;
                    else
                        this.Order.day = 1;
                    this.onChangeDay(this.Order.day);
                } else {
                    this.Order.orderCode = '';
                    this.Order.OrderName = '';
                }
            } else if(type.indexOf('Frequency')  >= 0 ) {
                if (result.code) {
                    this.frecuencyMode = result.AuxFields[1];

                    this.Order.mode = this.frecuencyMode;
                    this.Order.frequencyCode = result.code.trim();
                    this.Order.frequencyDescription = result.description.trim();

                    if (result.AuxFields[1] && result.AuxFields[1] === 'TIMED') {
                        await this.getMarsTimes();
                        if(this.marsTimes.length > 0){
                            this.PopulateDatesWithMarsTime(this.marsTimes);
                        }
                    } else if(result.AuxFields[1] && result.AuxFields[1] === 'STAT') {
                        await this.PopulateDatesNotTimed();
                        this.marsTimes = [];
                        this.Order.marsTimes = [];
                        this.Order.day = 1;
                        this.onChangeDay(1);
                    } else {       
                        this.marsTimes = [];
                        this.Order.marsTimes = [];
                        await this.PopulateDatesNotTimed();
                    }
                } else {
                    this.frecuencyMode = '';

                    this.Order.frequencyCode = '';
                    this.Order.frequencyDescription = '';
                }
                
            }
        },

        onChangeStartDateTime(){
            if (this.startDateTime && this.endDateTime) {
                if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat()) && Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    var date1 = moment(this.startDateTime, Utils.getDateTimeFormat())
                    var date2 = moment(this.endDateTime,Utils.getDateTimeFormat());
                    this.Order.day = date2.diff(date1,'days')+1; 
                    //this.getMedQuantityToOrder();
                } else {
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error"); 
                }
            }           
        },

        onChangeEndDateTime(){
            if(this.startDateTime && this.endDateTime){
                if(Utils.ValidateDate(this.startDateTime, Utils.getDateTimeFormat()) && Utils.ValidateDate(this.endDateTime, Utils.getDateTimeFormat())){
                    var date1 = moment(this.startDateTime,Utils.getDateTimeFormat());
                    var date2 = moment(this.endDateTime,Utils.getDateTimeFormat());
                    this.Order.day = date2.diff(date1,'days')+1;                
                    //this.getMedQuantityToOrder();
                } else {
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Shared.InvalidDate'),"error"); 
                }
            }
        },

        OnBlurDay(item){
            if (item <= 0){
                this.Order.day = 1;
            }
        },

        onChangeDay(item){    
            if (item <= 0){
                this.Order.day = 1;
            }       
            
            if(this.Order.day !== 0){
                if(this.Order.day > 0 && this.Order.day !== "" && this.Order.day !== null) {
                    let stime = Utils.formatTime(this.endDateTime, Utils.getDateTimeFormat());
                    let sDate = Utils.formatterDate(this.startDateTime, Utils.getDateTimeFormat());
                    let sDateTime = moment(sDate+" "+stime, 'YYYY-MM-DD hh:mm A').add(this.Order.day-1, 'd');
                    this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format());
                } else {
                    this.endDateTime = this.startDateTime;
                }
            }  
            
            this.setDayQuantityByOrder();     
        },

        ChangeDropDownOrderStatus(item) {
            if (item !== null) {
                const oldOrderStatus = this.Order.orderStatus;
                this.Order.orderStatus = item.value;
                if (item.value == 'Inactive' && this.Order.internalStatus != 'TARSCREATED' && this.Order.mode != 'PRN' && !this.physiciansOrdersOptions.inactiveOrdersAtAnyStatus) {
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Order.InactiveStatusTARCREATED'),"error"); 
                    setTimeout(() => this.Order.orderStatus = oldOrderStatus, 50);
                    return;
                } else if (item.value == 'Void' && this.Order.internalStatus != 'ORDERED') {
                    this.showMessage(this.$tc('Msg.Error'),this.$t('Order.VoidWhenStatusIsNotORDERED'),"error");
                    setTimeout(() => this.Order.orderStatus = oldOrderStatus, 50);
                    return;
                } else if (item.value == 'Void') {
                    this.Order.internalStatus = 'VOIDED';
                }

                if (item.value == "Inactive") {
                    this.getDateTime(true);
                }
            } else {
                this.Order.orderStatus = '';
            }
        },

        onChangeStopDateTime() {
            
        },

        async RefreshTime(obj){
            this.Order.marsTimes = obj.marsTimes;
            this.VisibleDosageTime = false;

            await this.getDateTimeUpdate();
            let sDate = Utils.formatterDate(this.DateandTimeUpdated, Utils.getShortDateFormat());            
            let sDateTime = moment(sDate+" "+obj.EndDateTime, 'YYYY-MM-DD hh:mm A');

            this.endDateTime = Utils.formatterDateTimeToString(sDateTime.format()); 
        },

        async PopulateDatesWithMarsTime(arr){     
            await this.getDateTimeUpdate();
            let hourNow = Utils.formatTime(this.DateandTimeUpdated, Utils.getDateTimeFormat());       
            let _starttime = hourNow;
            let _endtime = "";
            for (const time of arr) { 
                if(moment(hourNow, 'hh:mm A') < moment(time.adminTime, 'HH:mm')){
                    _starttime = Utils.formatTime(time.adminTime, 'HH:mm');
                    break;
                }
            } 
            _endtime = Utils.formatTime(arr[arr.length - 1].adminTime, 'HH:mm');  

            let st = this.startDateTime ? this.startDateTime.split(" ") : null;
            let et = this.endDateTime ? this.endDateTime.split(" ") : null;
            
            let stime = st !== null ? st[0]+" "+_starttime : this.DateandTimeUpdated;
            let etime = et !== null ? et[0]+" "+_endtime : this.DateandTimeUpdated;

            this.startDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(stime, Utils.getDateTimeFormat()));
            this.endDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(etime, Utils.getDateTimeFormat()));
        },

        async PopulateDatesNotTimed(){
            await this.getDateTimeUpdate();
            let et = this.DateandTimeUpdated ? this.DateandTimeUpdated.split(" ") : null;
            let etime = et !== null ? et[0]+" 11:59 PM" : this.DateandTimeUpdated;
            this.startDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(this.DateandTimeUpdated, Utils.getDateTimeFormat()));
            this.endDateTime = Utils.formatterDateTimeToString(Utils.formatDateTime(etime, Utils.getDateTimeFormat()));
        },

        PrescriberExist(code){    
            for(var i = 0; i < this.PrescriberList.length; i++){
                if( this.PrescriberList[i].code &&  this.PrescriberList[i].code.toUpperCase().trim() === code && code.toUpperCase().trim()){
                    return true;
                }
            }
            return false;
        },

        onSignature(value){  
            this.TypePassWord = 'Sign';       
            this.EmployeeCodeSelected = this.ModelPrescriber.code;
            this.showSignPassword = value;
        },

        onModalPasswordResult(result) {
            if(result.type === 'Sign'){
                if(result.Event === "Ok"){
                    if(result.status !== true) {
                        this.showMessage(this.$tc('Msg.Error'),result.message,"error");   
                        this.isSigned = false;                  
                    }                  
                } else {
                    this.isSigned = false;
                }  
            }
            this.showSignPassword = false;
        },

        setUsageDefault() {
            if (this.RegistrationInfo && this.RegistrationInfo.status == 'Inactive') 
                this.Order.usage = 'Home'
            else if (this.RegistrationInfo && this.RegistrationInfo.status == 'Active' &&  this.RegistrationInfo.isInpatient == 'Y')
                this.Order.usage = 'Internal'
            else
                this.Order.usage = 'Home'
        },

        async setDayQuantityByOrder () {
            await OrdersService
                .getOrdersSetup(this.Order.orderCode)
                .then((response) => {      
                    if (response.data) {              
                        this.DefaultDays = response.data.defaultDays;
                        this.RestrictChange = response.data.restrictChange;
                    }                     
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);                   
                }); 
        },

        async getMarsTimes() {          
            await OrdersService
                .getMarsTimes(this.Order.frequencyCode)
                .then((response) => {      
                    if (response.data) {              
                        let marsList = response.data;

                        if(marsList.length > 0){  
                            let arr = [];                  
                            marsList.forEach((item) => {                       
                                arr.push({adminTime:Utils.formatTimeHm(item.adminTime)});                                    
                            });

                            this.marsTimes = arr;
                            this.Order.marsTimes = [...marsList];
                        }
                    }                     
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);                   
                }); 
        },

        async getDateTime(changeStopDateTime) {
            await GlobalService
                .getDateTime()
                .then((response) => {      
                    if (response.data) {
                        if (changeStopDateTime)
                            this.Order.stopDateTime = Utils.formatterDateTimeToString(response.data); 
                        else {
                            this.CopyDateTime = Utils.formatterDateTimeToString(response.data);              
                            this.startDateTime = Utils.formatterDateTimeToString(response.data); 
                            this.endDateTime = Utils.formatterDateTimeToString(response.data);
                        }
                    }
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);
                }); 
        },

        async getPrescribers(){
            await MedicationService
                .getPrescribers()
                .then((response) => {
                    if(response.status == '200' && response.data){                        
                        this.PrescriberList = response.data;
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });        
        },

        async getDefaultDoctor() {
            await PatientService
                    .getDefaultDoctor(this.$route.params.id)
                    .then((response) => {
                        if(response.status == '200'){
                            this.defaultDoctor = response.data;

                            if (this.PrescriberExist(this.defaultDoctor.doctorCode)){
                                this.ModelPrescriber.code = this.defaultDoctor.doctorCode;
                                this.ModelPrescriber.name = this.defaultDoctor.doctorName;
                            }
                        }                  
                    })
                    .catch((error) => {   
                        this.showResponseErrorMessage(error);
                    });
        },

        async setDefaultDoctor() {
            if (this.physiciansOrdersOptions && this.physiciansOrdersOptions.usePatientDoctorAsPrescriber) {
                await this.getDefaultDoctor()
            } else {
                if (this.PrescriberExist(this.$store.state.employeeCode)) {
                    this.ModelPrescriber.code = this.$store.state.employeeCode;
                    this.ModelPrescriber.name = Utils.strToTitleCase(StorageService.getName());
                }       
            }
        },

        async getDateTimeUpdate() {         
            await GlobalService
                .getDateTime()
                .then((response) => {      
                    if (response.data) {
                        this.DateandTimeUpdated = Utils.formatterDateTimeToString(response.data);                     
                    }                     
                })
                .catch(error => {
                    this.showResponseErrorMessage(error);                  
                }); 
        },

        async getPhysiciansOrdersOptions(){
            await OrdersService.getPhysiciansOrdersOptions()
                .then((response) => {
                    if(response.status == '200' && response.data && response.data.length > 0){                
                        this.physiciansOrdersOptions = response.data[0];
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });        
        },

        async getOrderType(){
            await OrdersService.getOrderType()
                .then((response) => {
                    if(response.status == '200' && response.data){                
                        this.OrderTypeList = response.data.map((f) => {
                            return { code: f.code.trim(), description: f.description.trim() };
                        });
                    }
                })
                .catch((error) => {
                    this.showResponseErrorMessage(error);
                });        
        },

        async getCurrentAppointment() {
            this.currentAppointmentDB = await this.geCurrentAppointment(this.$route.params.actId);
            this.PatientTitle.activitytypename  = this.currentAppointmentDB.activitytypename
            this.PatientTitle.startdatetime = `${Utils.formatterDateToString(this.currentAppointmentDB.transdate)} ${this.currentAppointmentDB.timein}`  
        },

        async GetPatientByCode(){
            let infoList = await this.getInfoTitle(this.$route.params.id);
            if(infoList.length > 0){
                const { dob, firstname, lastname, age, ageFormatted } = infoList[0]; // Destructure for easier access

                if (ageFormatted) this.PatientTitle.ageFormatted = ageFormatted;
                if (dob) this.PatientTitle.dob = Utils.formatterDateToString(dob);
                if (age) this.PatientTitle.age = age;
                if (firstname) this.PatientTitle.fullName = firstname + ' '+ lastname;     
            }
        },

        async initialize() {
            const promises = [this.getPhysiciansOrdersOptions(), this.getPrescribers(), this.getOrderType()];
            await Promise.all(promises)
                    .then(() => this.$emit('load', true))
                    .catch((error) => {
                        this.$emit('load', false);
                        this.showResponseErrorMessage(error);
                    });
        },

        beforeWindowUnload(e) {
            if (this.pendingChanges) {
                e.preventDefault();
                e.returnValue = '';	
            }
        },
    },

    async mounted() {
        if (!this.IsAccessAllowed()) {
            return;
        }

        this.$emit('load', true);
        this.isSchedulerDB = this.$route.name.includes('Appointments-orders');
        this.OptionsRightMenu.visible = true;
        this.OptionsRightMenu.ItemsList = this.isSchedulerDB ? EnumService.AppointmentItems : EnumService.ClinicalItems
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
        this.$emit('getBtnRightMenu', this.OptionsRightMenu);
        this.isReadOnly = await this.$store.state.isPhysiciansOrderEHRReadOnly;

        if (this.isSchedulerDB) {
            await this.getCurrentAppointment()
            await this.GetPatientByCode();
        } else {
            this.RegistrationInfo = await this.getRegistrationInfoTitle(this.$route.params.recordid);
            const { dob, dateFrom, dateTo, age } = this.RegistrationInfo; // Destructure for easier access

            if (dateFrom) this.RegistrationInfo.dateFrom = Utils.formatterDateToString(dateFrom);
            if (dateTo) this.RegistrationInfo.dateTo = Utils.formatterDateToString(dateTo);	
            if (dob) this.RegistrationInfo.dob =  Utils.formatterDateToString(dob);
            if (age) this.RegistrationInfo.age = age === 0 ? "0" : age;
        }

        await this.getOrderByRecId();
        if (!this.Mode) {
            this.Order.orderStatus = 'Active';
            this.setUsageDefault();
            Promise.all([this.getDateTime(), this.setDefaultDoctor()])
                .then(() => this.$emit('load', false))
                .catch(() => this.$emit('load', false));
        } else {
            this.$emit('load', false);
        }
    },

    async created () {
        this.InitializePermissions('ListView', this.$store.state.isPhysiciansOrder);
        if (!this.IsAccessAllowed()) {
            return;
        }

        this.$emit('load', true);
        this.EmployeeCode = this.$store.state.employeeCode;
        await this.initialize();

        EventBus.$on("onChanged", function (e) {       
            this.pendingChanges = e.Changed;      
        }.bind(this));
        window.addEventListener('beforeunload', this.beforeWindowUnload)
    },

    destroyed(){
        this.OptionsRightMenu.ItemsList = [];
        this.OptionsRightMenu.Mode = false;
        this.OptionsRightMenu.visible = false; 
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    },

    beforeDestroy () {       
        if (!this.IsAccessAllowed()) {
            return;
        }

        window.removeEventListener('beforeunload', this.beforeWindowUnload)
    },
}
</script>